

<!------------ START TEMPLATE ------------>
<template>
  <div>
    <div class="vx-row">
      <div
        class="vx-col sm:w-1/3 w-full mb-6"
        :key="index"
        v-for="(item, index) in itens"
      >
        <label for class="vs-input--label"
          >{{ index + 1 }} - {{ item.descricao }}</label
        >
        <vs-switch
          class="mt-2"
          v-model="item.selecionado"
          color="success"
          @change="onChangeData()"
        >
          <span slot="on">sim</span>
          <span slot="off">não</span>
        </vs-switch>
      </div>
    </div>
    <div class="vx-row mt-4">
      <div class="vx-col sm:w-1/1 w-full mb-2">
        <vs-textarea
          label="Outras partes danificadas"
          v-model="outrasPartes"
          @change="onChangeData()"
        />
      </div>
    </div>
  </div>
</template>
<!------------ START TEMPLATE ------------>


<!------------ START SCRIPT ------------>
<script>
import service from "../../../services";

export default {
  components: {},
  props: ["partesDanificadas", "outrasPartesDanificadas"],
  watch: {
    partesDanificadas() {
      if (this.partesDanificadas) {
        this.itens = this.partesDanificadas;
      }
    },
    outrasPartesDanificadas() {
      this.outrasPartes = this.outrasPartesDanificadas;
    },
  },
  data() {
    return {
      outrasPartes: null,
      itens: [],
    };
  },
  methods: {
    onChangeData() {
      this.$emit("formAlterado", {
        partesDanificadas: this.itens,
        outrasPartesDanificadas: this.outrasPartes,
      });
    },
    buscaDados() {
      this.$vs.loading();

      const objSend = {
        idEvento: this.$route.params.idEvento,
      };

      service
        .post("Eventos", "BuscarPartesDanificadasAssociado", objSend)
        .then((res) => {
          if (!this.partesDanificadas)
            this.itens = [...res.data].map((i) => ({
              ...i,
              selecionado: i.selecionado === 1,
            }));

          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: e,
            color: "danger",
          });
          this.$vs.loading.close();
        });
    },
  },
  mounted() {
    this.buscaDados();
  },
};
</script>
<!------------ END SCRIPT ------------>


<!------------ START STYLE ------------>
<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
<style >
.con-vs-popup .vs-popup {
  width: 1000px !important;
}
</style>
<!------------ END STYLE ------------>
